import { fetchAuthSession } from 'aws-amplify/auth'
import { BrowserHeaders } from 'browser-headers'
import { createContext } from 'react'
import {
  GrpcWebImpl,
  StewardshipReportingService,
  StewardshipReportingServiceClientImpl,
} from '../proto/tumelo/stewardshipreporting/v1/service'
import { Config } from './environment'
import { sampleReports } from './samples/report'

export const MockReportingClient: StewardshipReportingService = {
  FetchMisalignmentReport: async (req) => {
    const after = req.filters?.meetingDateAfter
    const before = req.filters?.meetingDateBefore
    // create object of each report
    const allRows = sampleReports.map((report) => report())
    // allows filtering via date for sample data
    const rows = allRows.filter(({ generalMeetingDate }) => {
      if (!generalMeetingDate) return true
      if (after && generalMeetingDate < after) return false
      if (before && generalMeetingDate > before) return false
      return true
    })
    return {
      pagination: { currentPage: 1, pageSize: 10, total: rows.length },
      rows,
    }
  },
  GenerateMisalignmentReportDownloadLink: async () => ({
    links: ['https://www.tumelo.com/', 'https://mono.tumelo.com/'],
  }),
}

export const getMockedOrNotMockedReportingClient = ({
  clientType,
  clientAddress,
}: Config): (() => Promise<StewardshipReportingService>) => {
  if (clientType === 'mock') {
    return async () => MockReportingClient
  }
  return async () => {
    const session = await fetchAuthSession()
    const token = session.tokens?.idToken?.toString()
    const metadata = new BrowserHeaders({ Authorization: `Bearer ${token}` })
    return new StewardshipReportingServiceClientImpl(new GrpcWebImpl(clientAddress, { metadata }))
  }
}

export const ClientContext = createContext<() => Promise<StewardshipReportingService>>(() => {
  throw new Error('need to set client context value')
})
